import { useContextLoader } from "@/app/module/loader/index";
import { useMemo } from "react";

export function useLoader() {
  const { spinning, setLoader } = useContextLoader();

  return useMemo(() => ({ spinning, setLoader }), [spinning, setLoader]);
}
